// extracted by mini-css-extract-plugin
export var alignCenter = "_7g-d";
export var bannerShown = "_7g-6";
export var buttonContent = "_7g-0";
export var cardList = "_7g-1";
export var centerContent = "_7g-2";
export var chevron = "_7g-3";
export var closePanelButton = "_7g-k";
export var conversationContextContainer = "_7g-l";
export var conversationDetailContainer = "_7g-4";
export var detailWrapper = "_7g-7";
export var dropdownButton = "_7g-e";
export var dropdownTitle = "_7g-9";
export var fullHeight = "_7g-5";
export var hidden = "_7g-a";
export var icon = "_7g-b";
export var mergeSuggestionWrapper = "_7g-m";
export var panel = "_7g-i";
export var portalButtonsWrapper = "_7g-c";
export var right = "_7g-j";
export var tableSummaryContainer = "_7g-8";
export var tableSummaryHeader = "_7g-g";
export var threeDotsButton = "_7g-f";
export var wide = "_7g-h";